import { $, $$, insertHTML } from '../../utils/dom';
import { cookieBannerTemplate } from './cookiebanner-template';
import { checkCookie } from '../check-cookie';

export default class Cookiebanner {
  constructor(props) {
    this.cookieName = props.cookieName;
    this.cookieDuration = props.cookieDuration;
    this.cookieTypes = props.cookieTypes;
    this.onThirdPartyInit = props.onThirdPartyInit;
    this.inputObj = {};
    this.isProduction = window.location.href.includes(
      'www.innovative-frauen-im-fokus.de'
    );
    this.BREAKPOINTTABLET = 1024;
    this.openedByOpener = undefined;
  }

  init = () => {
    window.initGoogleMaps = false;
    // check if cookie exists (with the users choice to be tracked or not)
    if (document.cookie.indexOf(this.cookieName) < 0) {
      // if there is none, render the cookiebanner which will ask for his choice
      this.setDefaultAttributes();
      this.renderCookiebanner();
    } else {
      // set setDefaultAttributes based on cookies
      this.setDefaultAttributes(false);

      // create trackingscripts if user allowed analytics cookies
      this.cookieTypes.forEach((cookieType, index) => {
        if (checkCookie(this.cookieName).includes(`cookie-${index}`)) {
          // Load iframe on page load if user allowed external cookies
          // By default, every iframes on the page, wont/shouldnt be loaded!

          if (cookieType.type === 'script') {
            this.createTrackingScripts(cookieType.trackingScripts);
            cookieType.alreadySet = true;
          }

          if (cookieType.type === 'videojs' || cookieType.type === 'embed') {
            this.initThirdparty(cookieType.subType);
            cookieType.alreadySet = true;
          }
        }
      });

      // render cookiebanner (and hide it), so the user can re-do his choise anytime
      // pass in arguments, which section the user has agree/disgaree to
      this.renderCookiebanner(false);

      this.bindOpenerEvent();
    }
  };

  bindOpenerEvent = () => {
    const openerBtns = $$('[data-cookie-opener]');
    openerBtns.length &&
      openerBtns.forEach(openerBtn => {
        openerBtn.addEventListener('click', () => {
          const cookiebanner = $('.cookiebanner');
          if (cookiebanner) {
            openerBtn.setAttribute('aria-expanded', true);
            this.openedByOpener = openerBtn;
            cookiebanner.classList.remove('is-hidden');
            this.handleBodyScroll();
            this.banner.focus();
          }
        });
      });
  };

  setDefaultAttributes = (resetAll = true) => {
    this.cookieTypes.forEach((cookieType, index) => {
      if (!cookieType.isChecked) {
        if (resetAll) {
          cookieType.isChecked = false;
          cookieType.alreadySet = false;
        } else {
          const isSet = checkCookie(this.cookieName).includes(
            `cookie-${index}`
          );
          if (isSet) {
            cookieType.isChecked = true;
            cookieType.alreadySet = false;
          }
        }
      } else {
        cookieType.isChecked = true;
        cookieType.alreadySet = false;
      }
    });
  };

  renderCookiebanner = (showOnRender = true) => {
    // insert cookiebanner HTML
    insertHTML(
      $('body'),
      'beforeend',
      cookieBannerTemplate(showOnRender, this.cookieTypes)
    );

    this.banner = $('.cookiebanner');
    this.banner && this.banner.focus();

    // add event bindings
    this.bindCookiebannerEvents();
  };

  bindCookiebannerEvents = () => {
    this.initTabpanel();
    this.handleKeyboardNavigation();
    this.handleBodyScroll();
    this.bindCloseButtons();
  };

  initTabpanel = () => {
    // handle tab panels
    const tabButtons = $$('.cookie-tab-heading');
    const tabPanels = $$('.cookie-tab-panel');

    // set first panel to active by default
    tabButtons[0].setAttribute('aria-selected', 'true');
    tabPanels[0].setAttribute('aria-hidden', 'false');

    tabButtons.forEach(tabButton => {
      tabButton.addEventListener('click', () => {
        const target = tabButton.getAttribute('aria-controls');

        // reset all
        tabButtons.map(tabButton =>
          tabButton.setAttribute('aria-selected', 'false')
        );
        tabPanels.map(tabPanel => tabPanel.setAttribute('aria-hidden', 'true'));

        // set selected tab to active
        tabButton.setAttribute('aria-selected', 'true');
        $(`#${target}`).setAttribute('aria-hidden', 'false');
        $(`#${target}`).focus();
      });
    });
  };

  handleKeyboardNavigation = () => {
    const focusableElements = $('.cookiebanner').querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement =
      focusableElements[focusableElements.length - 1];

    this.banner && this.banner.focus();

    document.addEventListener('keydown', e => {
      const isCheckbox = e.target.getAttribute('type') === 'checkbox';

      // toggle cookie checkboxes via keyboard
      if (e.key === 'Enter' && isCheckbox) {
        e.target.checked = !e.target.checked;
      }

      // trap focus
      if (e.key === 'Tab' && e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else if (e.key === 'Tab') {
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    });
  };

  handleBodyScroll = () => {
    if (window.innerWidth <= this.BREAKPOINTTABLET) {
      const bannerIsHidden = this.banner.classList.contains('is-hidden');
      bannerIsHidden
        ? ($('html').style.overflow = '')
        : ($('html').style.overflow = 'hidden');
    }
  };

  bindCloseButtons = () => {
    // close cookiebanner and create cookies
    const closeButtons = $$('.cookiebanner .close-cookiebanner');
    closeButtons.length &&
      closeButtons.forEach(closeButton => {
        closeButton.addEventListener('click', () => {
          this.inputObj = {};
          const checkboxes = $$('.cookiebanner input[type="checkbox"]');

          // get value of checkboxes
          checkboxes.length &&
            checkboxes.forEach((checkbox, index) => {
              // check every checkbox if user clicked to "all" button, before closing cookiebanner
              if (closeButton.dataset.confirm === 'all') {
                checkbox.checked = true;
              }
              this.cookieTypes[index].isChecked = checkbox.checked;
              this.inputObj[`${checkbox.id}`] = checkbox.checked;
            });

          this.closeCookiebanner();
        });
      });
  };

  closeCookiebanner = () => {
    // create the cookie
    this.createCookie(this.cookieName, this.inputObj, this.cookieDuration);

    if (this.isProduction) {
      // check for user consent and handle loading external scripts and videos
      this.handleExternalScripts();

      // reload page
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    }

    $('.cookiebanner').classList.add('is-hidden');
    this.handleBodyScroll();
    if (this.openedByOpener) {
      this.openedByOpener.setAttribute('aria-expanded', false);
      this.openedByOpener.focus();
      this.openedByOpener = undefined;
    }
  };

  handleExternalScripts = () => {
    this.cookieTypes.forEach(cookieType => {
      if (
        cookieType.subType === 'matomo' &&
        cookieType.alreadySet &&
        !cookieType.isChecked
      ) {
        // if a user withdraws consent, opt out and reload the page so _pk cookies are deleted and mtm_consent_removed cookie is set
        // eslint-disable-next-line no-undef
        _paq.push(['optUserOut']);
      }

      if (!cookieType.alreadySet && cookieType.isChecked) {
        if (cookieType.type === 'script') {
          this.createTrackingScripts(cookieType.trackingScripts);
          cookieType.alreadySet = true;
        }

        if (cookieType.type === 'videojs' || cookieType.type === 'embed') {
          this.initThirdparty(cookieType.subType);
          cookieType.alreadySet = true;
        }
      }
    });
  };

  createTrackingScripts = trackingScripts => {
    if (trackingScripts.length) {
      trackingScripts.forEach(tracking => {
        const insertSelector = tracking.insertSelector;

        if (tracking.script) {
          this.createScriptTag('script', tracking.script, insertSelector);
        }

        if (tracking.noscript) {
          this.createScriptTag('noscript', tracking.noscript, insertSelector);
        }
      });
    }
  };

  createScriptTag = (tagType, script, insertSelector) => {
    const newScript = document.createElement(tagType);
    const inlineScript = document.createTextNode(script);

    newScript.appendChild(inlineScript);
    document.querySelector(insertSelector).appendChild(newScript);
  };

  // this part can differs for each project, so you have to handle this part yourself
  initThirdparty = subType => this.handleThirdParty(subType);

  handleThirdParty = subType => {
    this.onThirdPartyInit && this.onThirdPartyInit(subType);
  };

  createCookie = (cookieName, cookieValueObj, cookieDuration) => {
    let expires = '';
    let cookieValue = '';
    const days = cookieDuration;

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toGMTString()}`;
    } else {
      expires = '';
    }

    const valueArray = [];
    Object.entries(cookieValueObj).forEach(item => {
      const key = item[0];
      const value = item[1];
      if (value) valueArray.push(key);
    });

    if (valueArray.length) {
      cookieValue = valueArray.map(value => value).join(',');
    } else {
      cookieValue = 'false';
    }

    document.cookie = `${cookieName}=${cookieValue}${expires}; path=/; samesite=strict`;
  };
}
